const generateDates = () => {
  const dates: string[] = [];
  const today = new Date();
  for (let i = 29; i >= 0; i--) {
    const d = new Date(today);
    d.setDate(d.getDate() - i);
    dates.push(d.toISOString().split("T")[0]); // YYYY-MM-DD
  }
  return dates;
};

const generateData = (min: number, max: number) =>
  Array.from({ length: 30 }, () => Math.floor(Math.random() * (max - min + 1)) + min);

export const fourChartsData = {
  labels: generateDates(),
  datasets: [
    {
      label: "UPS B",
      data: generateData(50, 75),
      borderColor: "#2DC75C",
      fill: 'origin',    // fill down to x-axis
      order: 1,          // drawn first
      tension: 0.4,
      pointRadius: 0,
      pointHoverRadius: 0,
      backgroundColor: (context: any) => {
        const chart = context.chart;
        const { ctx, chartArea } = chart;
        if (!chartArea) return null;

        const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
        gradient.addColorStop(0, "rgba(45, 199, 92, 0.8)"); // start at 25% from top
        gradient.addColorStop(0.25, "rgba(45, 199, 92, 0.1)");
        gradient.addColorStop(1, "rgba(45, 199, 92, 0)"); // fade to transparent
        return gradient;
      },
    },
    {
      label: "UPS C",
      data: generateData(25, 50),
      borderColor: "#FFDC4A",
      fill: 'origin',
      order: 2,          // drawn over UPS B
      tension: 0.4,
      pointRadius: 0,
      pointHoverRadius: 0,
      backgroundColor: (context: any) => {
        const chart = context.chart;
        const { ctx, chartArea } = chart;
        if (!chartArea) return null;

        const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
        gradient.addColorStop(0, "rgba(255, 220, 74, 0.8)");
        gradient.addColorStop(0.25, "rgba(255, 220, 74, 0.1)");
        gradient.addColorStop(1, "rgba(255, 220, 74, 0)");
        return gradient;
      },
    },
    // {
    //   label: "UPS A",
    //   data: generateData(85, 90),
    //   borderColor: "#659DF2",
    //   fill: 'origin',
    //   order: 3,          // drawn over UPS C
    //   tension: 0.4,
    //   pointRadius: 0,
    //   pointHoverRadius: 0,
    //   backgroundColor: (context: any) => {
    //     const chart = context.chart;
    //     const { ctx, chartArea } = chart;
    //     if (!chartArea) return null;

    //     const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
    //     gradient.addColorStop(0, "rgba(101, 157, 242, 0.4)");
    //     gradient.addColorStop(0.25, "rgba(101, 157, 242, 0.1)");
    //     gradient.addColorStop(1, "rgba(101, 157, 242, 0)");
    //     return gradient;
    //   },
    // },
    {
      label: "UPS D",
      data: generateData(0, 25),
      borderColor: "#FF6464",
      backgroundColor: "rgba(255, 100, 100, 0.2)",
      fill: 'origin',
      order: 100,          // drawn on top
      tension: 0.4,
      pointRadius: 0,
      pointHoverRadius: 0,
    },
  ],
};

function hexToRgba(hex: string, opacity: number) {
  // Remove the leading "#" if present
  hex = hex.replace(/^#/, '');

  // Handle shorthand hex (#RGB → #RRGGBB)
  if (hex.length === 3) {
    hex = hex.split('').map(char => char + char).join('');
  }

  // Convert hex to RGB
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  // Return as rgba string
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}


export const singleChartData = ({ color }: { color: string }) => {
  return {
    labels: generateDates(),
    datasets: [
      {
        label: "UPS B",
        data: generateData(50, 75),
        borderColor: color, // fully opaque line color
        fill: "origin",
        order: 1,
        tension: 0.4,
        pointRadius: 0,
        pointHoverRadius: 0,
        backgroundColor: (context: any) => {
          const chart = context.chart;
          const { ctx, chartArea } = chart;
          if (!chartArea) return null;

          const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);

          // Use the dynamic color with opacity
          gradient.addColorStop(0, hexToRgba(color, 0.8));
          gradient.addColorStop(0.25, hexToRgba(color, 0.1));
          gradient.addColorStop(1, hexToRgba(color, 0));

          return gradient;
        },
      },
    ],
  };
};
